import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { COUNTRY_OPTIONS } from '../data/countryContent';
import { useCountry } from '../contexts/CountryContext';

// Header country picker — lets users manually choose which country's tax
// features the landing page shows (overrides IP auto-detection, remembered).
export const CountrySelector = () => {
  const { region, setRegion } = useCountry();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onClick);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onClick); document.removeEventListener('keydown', onKey); };
  }, []);

  const current = COUNTRY_OPTIONS.find((c) => c.key === region) || COUNTRY_OPTIONS[0];

  return (
    <div className="relative" ref={ref} data-testid="country-selector">
      <button
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
        data-testid="country-selector-btn"
        className="flex items-center gap-1.5 px-3 py-2 rounded-full border border-[#84CC16]/40 bg-white text-sm font-semibold text-[#064E3B] hover:border-[#84CC16] transition-colors"
      >
        <span className="text-base leading-none">{current.flag}</span>
        <span className="hidden lg:inline">{current.name}</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-56 bg-white rounded-xl shadow-2xl border border-gray-100 p-1.5 z-50" role="menu" data-testid="country-selector-menu">
          <p className="px-3 py-1.5 text-[11px] font-bold uppercase tracking-wider text-gray-400">Show tax features for</p>
          {COUNTRY_OPTIONS.map((c) => (
            <button
              key={c.key}
              onClick={() => { setRegion(c.key); setOpen(false); }}
              data-testid={`country-option-${c.key}`}
              role="menuitem"
              className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm font-semibold text-left transition-colors ${c.key === region ? 'bg-[#F0FDF4] text-[#064E3B]' : 'text-[#064E3B] hover:bg-gray-50'}`}
            >
              <span className="text-base leading-none">{c.flag}</span>
              <span className="flex-1">{c.name}</span>
              {c.key === region && <Check className="h-4 w-4 text-[#84CC16]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CountrySelector;
